import { memo } from 'react';

import InsightsIconSVG from '@/assets/insights-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IInsightsIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={InsightsIconSVG} {...props} />;

export const InsightsIcon = memo(IInsightsIcon) as typeof IInsightsIcon;
